/* eslint-disable @typescript-eslint/no-empty-interface */
import React from 'react';
import { Loader } from 'src/components';
import styles from './Desktop.module.css';
import { CandidateAppliedJobsViewRendererProps } from '../../types';
import AppliedJobsList from '../../components/AppliedJobsList';

function Desktop(props: CandidateAppliedJobsViewRendererProps) {
  const {
    appliedJobs,
    jobStatuses,
    loading,
    loadingHistory,
    profileInfo,
    updatingForm,
    jobHistory,
    updateJobStatus,
    getCandidateJobHistory,
    updateCandidateComments,
  } = props;

  if (loading) {
    return (
      <div className="top-[50vh] left-[50vw] fixed">
        <Loader />
      </div>
    );
  }

  return (
    <>
      <div className={styles.root}>
        <AppliedJobsList
          loadingHistory={loadingHistory}
          appliedJobs={appliedJobs}
          jobStatuses={jobStatuses}
          jobHistory={jobHistory}
          profileInfo={profileInfo}
          updateJobStatus={updateJobStatus}
          getCandidateJobHistory={getCandidateJobHistory}
          updateCandidateComments={updateCandidateComments}
        />
      </div>
      {(updatingForm) && (
        <div className="top-[50vh] left-[50vw] fixed">
          <Loader text="Updating ..." />
        </div>
      )}
    </>
  );
}

export default Desktop;
